import { TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { handleConnectionDetailChange } from '../../../utils';

interface GCSBucketFieldsProps {
  isEditable: boolean;
  formValues: Record<string, string | string[]>;
  handleInputChange: (name: string, value: string) => void;
  onValidityChange: (isValid: boolean) => void;
}

// const GCS_BUCKET_PATH_REGEX = /^gs:\/\/[^/]+\//;
// const IAP_FILE_NAME_REGEX =
//   /^[A-Za-z0-9]+_IAP_\d{4}_\d{2}_\d{2}_\d{2}_\d{2}\.csv$/;
// const IAA_FILE_NAME_REGEX =
//   /^[A-Za-z0-9]+_IAA_\d{4}_\d{2}_\d{2}_\d{2}_\d{2}\.csv$/;
// const UA_FILE_NAME_REGEX = /^[A-Za-z0-9]+_UA\.csv$/;

const GCSBucketFields: React.FC<GCSBucketFieldsProps> = ({
  isEditable,
  formValues,
  handleInputChange,
  onValidityChange,
}) => {
  const connectionDetails = JSON.parse((formValues.connectionDetails as string) || '{}');
  const [isTouched, setIsTouched] = useState({
    path: false,
    iapFileName: false,
    iaaFileName: false,
    uaFileName: false,
  });

  useEffect(() => {
    const isPathValid = !!connectionDetails.gcsBucketPath;
    const isIAPValid = !!connectionDetails.iapFileName;
    const isIAAValid = !!connectionDetails.iaaFileName;
    const isUAValid = !!connectionDetails.uaFileName;

    const isAllValid = isPathValid && isIAPValid && isIAAValid && isUAValid;
    onValidityChange?.(isAllValid);
  }, [
    connectionDetails.gcsBucketPath,
    connectionDetails.iapFileName,
    connectionDetails.iaaFileName,
    connectionDetails.uaFileName,
  ]);

  return (
    <>
      <TextField
        label="GCS Bucket Path"
        placeholder="e.g. gs://your-bucket-name/data/"
        sx={{
          width: '100%',
        }}
        value={connectionDetails.gcsBucketPath}
        error={!connectionDetails.gcsBucketPath && isTouched.path}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            path: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange(
            'gcsBucketPath',
            e.target.value,
            formValues,
            handleInputChange,
          )
        }
        disabled={!isEditable}
      />
      <TextField
        label="IAP File Name"
        placeholder="e.g. mygame_IAP_2025_02_01_10_30.csv"
        sx={{
          width: '100%',
        }}
        value={connectionDetails.iapFileName}
        error={!connectionDetails.iapFileName && isTouched.iapFileName}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            iapFileName: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange('iapFileName', e.target.value, formValues, handleInputChange)
        }
        disabled={!isEditable}
      />
      <TextField
        label="IAA File Name"
        placeholder="e.g. mygame_IAA_2025_02_01_10_30.csv"
        sx={{
          width: '100%',
        }}
        value={connectionDetails.iaaFileName}
        error={!connectionDetails.iaaFileName && isTouched.iaaFileName}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            iaaFileName: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange('iaaFileName', e.target.value, formValues, handleInputChange)
        }
        disabled={!isEditable}
      />
      <TextField
        label="UA File Name"
        placeholder="e.g. mygame_UA.csv"
        sx={{
          width: '100%',
        }}
        value={connectionDetails.uaFileName}
        error={!connectionDetails.uaFileName && isTouched.uaFileName}
        onBlur={(e) => {
          setIsTouched((prev) => ({
            ...prev,
            uaFileName: true,
          }));
        }}
        onChange={(e) =>
          handleConnectionDetailChange('uaFileName', e.target.value, formValues, handleInputChange)
        }
        disabled={!isEditable}
      />
    </>
  );
};

export default GCSBucketFields;
